module.exports = __webpack_public_path__ + "static/beauty2-303837a73622a69a36999ff4cbd62aaf.jpg";